import axios from 'axios';
import { getOrSetTraceId, generateSpanId } from '../Services/session.mgmt';

export const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL: baseURL,
  });

// Add a request interceptor
  instance.interceptors.request.use(
    function (config) {
      config.withCredentials = true;
      const traceId = getOrSetTraceId();
      const spanId = generateSpanId();
      config.headers['X-Cloud-Trace-Context'] = `${traceId}/${spanId};o=1`;
      return config;
    },
    function (error) {
      console.log('Error sending request === ' + JSON.stringify(error));
      return Promise.reject(error);
    }
  );

// Add a response interceptor
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      console.log('Error with response === ' + JSON.stringify(error));
      return Promise.reject(error);
    }
  );

  return instance;
};

export const serviceAxiosInstance = createAxiosInstance(process.env.REACT_APP_SERVICE_BASE_URL);
export const serviceAxiosInstanceFcna = createAxiosInstance(process.env.REACT_APP_SERVICE_BASE_URL_FCNA);
export const serviceAxiosInstanceAct = createAxiosInstance(process.env.REACT_APP_SERVICE_BASE_URL_ACT);
